import { render, staticRenderFns } from "./resetTel.vue?vue&type=template&id=0fe284e5&scoped=true&"
import script from "./resetTel.vue?vue&type=script&lang=js&"
export * from "./resetTel.vue?vue&type=script&lang=js&"
import style0 from "./resetTel.vue?vue&type=style&index=0&id=0fe284e5&lang=less&scoped=true&"
import style1 from "./resetTel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe284e5",
  null
  
)

export default component.exports